import { Company } from 'models'

type SelectionSummary =
  | { type: 'none'; company?: undefined }
  | { type: 'single'; company: Company }
  | { type: 'multiple'; companies: Array<Company> }
  | { type: 'allAccounts'; company: Company }

const EMPTY_SELECTION_SUMMARY: SelectionSummary = { type: 'none' }

export { EMPTY_SELECTION_SUMMARY }
export type { SelectionSummary }
